import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { PagerserviceService } from "../services/pagerservice.service";
import { NotificationsService } from "angular2-notifications";
import { UserPayload, UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { AdminService } from "../services/admin.service";
import * as XLSX from 'xlsx';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material';

@Component({
    selector: 'app-manage-address-whitelist',
    templateUrl: './manage-address-whitelist.component.html',
    styleUrls: ['./manage-address-whitelist.component.css']
})
export class ManageAddressWhitelistComponent implements OnInit {
    isToggled: boolean = false;
    filteredWhiteList: any[];
    whiteList: Array<any>;
    customerFlag = false;
    /* Add New customer */
    customer: Boolean;
    customersList: Boolean;
    /* Pagination fields */
    // pager Number
    pager: number;

    // pager object
    pager1: any = {};
    Tpager: number;
    // paged items
    pagedItems: Array<any>;

    /*Filter variables*/
    serach: string;
    FilPerpage: number;
    FilPage: number;
    customerid = '';

    /* Bank Object */
   
    currentPag: any = 0;
    /* For Add New Customer Object */
    userobj: UserPayload = {
       
        _csrf: null,
    };
    
    permission: string;
    liqprovider = [];
    totalRecords = 0;
    countries: any[];
    constructor(private userService: UserService,
        private router: Router,
        private notifSer: NotificationsService,
        private spinnerService: Ng4LoadingSpinnerService,
        private pagerService: PagerserviceService,
        private adminService: AdminService,
        private dialog: MatDialog,
        ) { }
    public declarativeFormCaptchaValue: string;
    ngOnInit() {
        // check user is logged or not
        if (!this.userService.isLoggedIn()) {
            this.router.navigateByUrl('/index');
        } else {
            if (typeof localStorage.getItem('adminmenus') != 'undefined' && localStorage.getItem('adminmenus').length > 0) {
                var spt = this.router.url.split("/");
                var menu_url = spt[1];
                var adminmenus = JSON.parse(localStorage.getItem('adminmenus'));
                var adminrules = JSON.parse(localStorage.getItem('adminrules'));
                var index = adminmenus.findIndex(x => (x.menu_url) === menu_url);
                if (index != -1) {
                    var menuid = adminmenus[index]._id;
                    var adindex = adminrules.findIndex(x => (x.menu_id) === menuid.toString());
                    this.permission = (adindex != -1) ? adminrules[adindex].permission : "write";
                }
            }
          
            this.customersList = true;
           
            this.serach = '';
            this.FilPerpage = 10;
            this.FilPage = 1;
            this.pager = 1;
           
                this.csrf();
            
        }
    }

    csrf() {
        this.userService.csrf().subscribe((success) => {
            this.userobj._csrf = success._csrf
            if (typeof this.customerid == 'undefined' || !this.customerid) {
                this.getWithdrawWhitelist();
            }
        }, (error) => {
            this.notifSer.error(
                'Error',
                error.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    RefreshData(){
        this.getWithdrawWhitelist();
    }
    filteredPendingRecord() {
        this.filteredWhiteList = this.isToggled ? this.whiteList.filter((obj) => obj.status === 'PENDING') : this.whiteList;
    }
    onToggle() {
        this.isToggled = !this.isToggled;
        // Filter the records based on the toggle state
        this.filteredPendingRecord();
    }
    getWithdrawWhitelist() {
        this.spinnerService.show();
        this.adminService.WithdrawWhitelist(this.FilPerpage, this.FilPage, this.serach, this.userobj._csrf).subscribe(list => {
             
            this.whiteList = list.addresslist;
            this.Tpager = list.pages;
            this.currentPag = list.current
            this.setPage(this.FilPage);
            // Initialize filteredWhiteList with all records when the data is fetched
            this.filteredWhiteList = this.whiteList.slice();
            this.filteredPendingRecord();
            this.customerFlag = true;
            this.totalRecords = list.total;
            this.spinnerService.hide();
        }, (err) => {
            this.spinnerService.hide();
            this.notifSer.error(
                'Error',
                err.error.message,
                {
                    timeOut: 3000,
                    showProgressBar: true,
                    pauseOnHover: false,
                    clickToClose: true,
                    maxLength: 50
                }
            )
        })
    }
    /* Pagination of customer details */
    setPage(page: number) {
        // get pager object from service
        this.pager1 = this.pagerService.getPager(this.Tpager, page);
    }

    setPageOnClick(page: number) {
        this.pager = page;
        this.FilPage = this.pager;
        this.getWithdrawWhitelist();
    }

    /* Serach Event */
    sreach(event: any) {
        this.serach = event.target.value;
        this.getWithdrawWhitelist();
    }

    Whitelistaction(data, status) {
        console.log(data);
        let { _id, userEmail, userName, currency, address } = data;
        this.spinnerService.show();
        const obj = {
            id: _id,
            userEmail,
            userName,
            status,
            currency,
            address,
            '_csrf': this.userobj._csrf
        }
        this.dialog.open(ConfirmationDialogComponent, {
            data: {
                message: 'Are you sure want to confirm?',
                buttonText: {
                    ok: 'Yes',
                    cancel: 'Cancel'
                }
            }
        }).afterClosed().subscribe((confirmed: boolean) => {
            if (confirmed) {
                this.adminService.Whitelistaction(obj).subscribe(done => {
                    this.getWithdrawWhitelist();
                    this.spinnerService.hide();
                    if(done.status) {
                        this.notifSer.success(
                            'Success',
                            done.message,
                            {
                                timeOut: 3000,
                                showProgressBar: true,
                                pauseOnHover: false,
                                clickToClose: true,
                                maxLength: 50
                            }
                        )
                    }else {
                        this.notifSer.error(
                            'Error',
                            done.message,
                            {
                                timeOut: 3000,
                                showProgressBar: true,
                                pauseOnHover: false,
                                clickToClose: true,
                                maxLength: 50
                            }
                        )
                    }
                }, (err) => {
                    this.spinnerService.hide();
                    this.notifSer.error(
                        'Error',
                        err.message,
                        {
                            timeOut: 3000,
                            showProgressBar: true,
                            pauseOnHover: false,
                            clickToClose: true,
                            maxLength: 50
                        }
                    )
                })
            }
        });
    }

    exportExcel(ref: string) {
        this.adminService.WithdrawWhitelist(this.FilPerpage, this.FilPage, this.serach, this.userobj._csrf).subscribe(whitelist => {
            if (whitelist.status) {
                let exportreflist = [];
                let addresslist =  this.isToggled ? whitelist.addresslist.filter((obj) => obj.status === 'PENDING') : whitelist.addresslist;
                for (let i = 0; i < addresslist.length; i++) {
                exportreflist.push({
                    'User Email': addresslist[i].userEmail ? addresslist[i].userEmail : '',
                    'Currency Name': addresslist[i].currency ? addresslist[i].currency : '',
                    'Blockchain': addresslist[i].blockchain ? addresslist[i].blockchain : '' ,
                    'Address': addresslist[i].address ? addresslist[i].address : '',
                    'Destination Tag': addresslist[i].destinationTag ? addresslist[i].destinationTag : '',
                    'Note': addresslist[i].note ? addresslist[i].note : '',
                    'Status': addresslist[i].status ? addresslist[i].status : '',
                })
                }
                let fileName = 'User Withdrawal Address Whitelist Report.xlsx';
                console.log(exportreflist)
                const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportreflist);
                /* generate workbook and add the worksheet */
                const wb: XLSX.WorkBook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
                /* save to file */
                XLSX.writeFile(wb, fileName);
            }
        });
        
    }

}



// WEBPACK FOOTER //
// ./src/app/manage-address-whitelist/manage-address-whitelist.component.ts